
import { MyProfileModel } from "@dana/Services/DanaMyProfileService";
import MyProfileState from "@dana/Store/Data/MyProfile/MyProfileState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialCounterState: MyProfileState = {
    personalInformation: {} as any,
    professionalInformation: {} as any,
    isLoading: false,
};

const myProfileStateImmerReducer = createTypedReducerWithImmer(initialCounterState, {
    "MyProfile/BeginLoad": (draft: Draft<MyProfileState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
    },
    "MyProfile/CompleteLoadProfile": (draft: Draft<MyProfileState>, action: { myProfileModel: MyProfileModel }) => {
        const myprofile = action.myProfileModel;
        draft.personalInformation = myprofile.personalInformation ?? {};
        draft.professionalInformation = myprofile.professionalInformation;
    },
    "MyProfile/EndLoad": (draft: Draft<MyProfileState>, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
        
    },
});


(reducers as any).myProfileState = myProfileStateImmerReducer;

type MyProfileReducers = {
    myProfileState: typeof myProfileStateImmerReducer;
};

export type MyProfileActions = Parameters<MyProfileReducers[keyof MyProfileReducers]>[1] | AnyAction;


